import styled from "styled-components";

const TabMenuStyled = styled.div`
  background-color: ${props => props.theme.lightGray};
  padding: 1.1rem 1.6rem 0;

      
  @media only screen and (min-width: ${props => props.theme.tablet}) {
    padding: 1.1rem 4.8rem 0;
  }
`;

export {TabMenuStyled};